import { FC } from 'react';
import { BorderedContainer } from 'core/components/common/BorderedContainer';
import { SectionTitle } from 'core/components/common/SectionTitle';
import { InfoDisplay } from 'core/components/JianDetail/common/InfoDisplay';

type Props = {
  activitySummary?: string | null;
};

export const ActivitySummaryView: FC<Props> = ({ activitySummary }) => (
  <BorderedContainer>
    <div className="flex flex-col gap-[24px]">
      <SectionTitle text="活動概要" />
      <div className="flex flex-col gap-6">
        <InfoDisplay title="活動概要" content={activitySummary ?? ''} />
      </div>
    </div>
  </BorderedContainer>
);
